/* eslint-disable no-console */
import debugFactory from "debug";
import postal from "postal";
import isArray from "lodash/isArray";

const debug = debugFactory( "teaming:engine:appDispatch" );

const facadeMap = {};
const ioChannel = postal.channel( "teaming.io" );

export const appChannels = {
	ioChannel,
};

// NOTE: we only currently have an "io" channel
// If we add more channels, we'll need to make the channel used inside this method configurable per call
export function makeDispatchable( module ) {
	facadeMap[ module.namespace ] = new Set();

	// create a facade to return to the caller that wires the io module into the msg broker
	const facade = Object.keys( module ).reduce( ( acc, key ) => {
		// skip non-function members
		if ( typeof module[ key ] !== "function" ) {
			return acc;
		}

		facadeMap[ module.namespace ].add( key );

		acc[ key ] = async function( ...args ) {
			debug( `${ module.namespace }.${ key }`, ...args );

			ioChannel.publish(
				`${ module.namespace }.${ key }.invoked`,
				{
					// TODO - eventually we'll want a ticket # here...
					response: null,
					args,
				}
			);

			let result = null;
			let err = null;

			try {
				result = await module[ key ]( ...args );
			} catch ( e ) {
				err = e;
			}

			if ( err ) {
				ioChannel.publish(
					`${ module.namespace }.${ key }.error`,
					{
						// TODO - eventually we'll want a ticket # here...
						response: err,
						args,
					}
				);
				throw err;
			}

			ioChannel.publish(
				`${ module.namespace }.${ key }.success`,
				{
					// TODO - eventually we'll want a ticket # here...
					response: result?.data || result,
					args,
				}

			);

			return result;
		};

		return acc;
	}, { ...module, } );

	// subscribe the io module to the msg bus for invocations
	ioChannel.subscribe( `${ module.namespace }.#.invoke`, ( data, env ) => {
		const handler = env.topic.split( "." )[ 1 ];
		if ( !handler ) {
			console.error( `IO module ${ module.namespace } does not have handler ${ handler }` );
			return;
		}
		facade[ handler ]( ...( isArray( data ) ? data : [ data, ] ) );
	} );

	return facade;
}

export function mapIoActions( namespace, actionNames ) {
	return actionNames.reduce( ( acc, actionName ) => {
		if ( facadeMap[ namespace ].has( actionName ) ) {
			acc[ actionName ] = ( ...args ) => {
				ioChannel.publish( `${ namespace }.${ actionName }.invoke`, args );
			};
		} else {
			console.error( `The action "${ actionName }" does not exist under the ${ namespace } namespace.` );
		}
		return acc;
	}, {} );
}
